import { useMemo } from "react";
import { buildSuggestionInfoMap } from "../process-flow/core/builder";
/**
 * The proposed-name/status map a step-detail surface needs so a
 * `suggestion`-typed assignee / helper / successor / rule ref renders its
 * proposed name (blue, or red once declined) instead of a bare placeholder.
 *
 * The union rule lives here once because the two sources are incomplete in
 * opposite directions, and getting it wrong is silent — a ref simply degrades
 * to a placeholder:
 *
 * - the step's own denormalized `entitySuggestions[]` is incomplete on the
 *   PUBLISHED path (a successor suggestion raised in a neighbouring step is
 *   referenced here but stored there), and
 * - the process-wide set is absent on the EDITOR path, which floods the
 *   draft-wide set onto each step and passes no second argument at all.
 *
 * The process-wide set is applied LAST so it wins on a duplicate id, and
 * `buildSuggestionInfoMap` dedupes by id — so passing a superset that already
 * contains the step's own entries is harmless.
 */ export function useStepSuggestionInfoMap(step, entitySuggestions) {
    return useMemo(()=>buildSuggestionInfoMap([
            ...step.entitySuggestions ?? [],
            ...entitySuggestions ?? []
        ]), [
        step.entitySuggestions,
        entitySuggestions
    ]);
}

//# sourceMappingURL=useStepSuggestionInfoMap.js.map